<template>
  <div class="relative overflow-hidden p-6 italic bg-white font-open-sans">
    <div class="flex flex-row justify-center py-2">{{ referencesTitle }}</div>
    <div v-for="(reference, index) in references" :key="index" class="flex justify-center text-sm py-2">
      <sup>{{ index + 1 }}</sup> <div v-html="reference.text"></div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  referencesTitle: {
    type: String,
    default: 'References:'
  },
  references: {
    type: Array,
    default: () => [
      {
        text: 'HopkinsMedicine.org, [9 Reasons Why (the Right Amount of) Coffee is Good for You](https://www.hopkinsmedicine.org/health/wellness-and-prevention/9-reasons-why-the-right-amount-of-coffee-is-good-for-you)'
      },
      {
        text: 'M L Martins, H M Martins, A Gimeno, 2003, [Incidence of microflora and of ochratoxin A in green coffee beans (Coffea arabica)](https://pubmed.ncbi.nlm.nih.gov/14726276/)'
      },
      // ... Add additional references here
    ]
  }
});

defineBuilderComponent({
    friendlyName: "References",
    inputs: [
        {
            name: "referencesTitle",
            type: "string",
            defaultValue: "References:"
        },
        {
            name: "references",
            type: "list",
            defaultValue: [
                {
                    text: "HopkinsMedicine.org, [9 Reasons Why (the Right Amount of) Coffee is Good for You](https://www.hopkinsmedicine.org/health/wellness-and-prevention/9-reasons-why-the-right-amount-of-coffee-is-good-for-you)"
                },
                {
                    text: "M L Martins, H M Martins, A Gimeno, 2003, [Incidence of microflora and of ochratoxin A in green coffee beans (Coffea arabica)](https://pubmed.ncbi.nlm.nih.gov/14726276/)"
                }
            ],
            subFields: [
                {
                    name: "text",
                    type: "richText"
                }
            ]
        }
    ]
});
</script>